import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "72",
  height: "72",
  viewBox: "0 0 72 72",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "icon-ui-nav-confirmed-gifts", -1),
    _createElementVNode("path", {
      d: "M8.486 8.486v55.028h55.028V8.486H8.486zM5.143 0h61.714A5.143 5.143 0 0 1 72 5.143v61.714A5.143 5.143 0 0 1 66.857 72H5.143A5.143 5.143 0 0 1 0 66.857V5.143A5.143 5.143 0 0 1 5.143 0zm14.864 32.049l-6.585 7.902 19.415 16.18 26.43-32.303-7.962-6.513L31.45 41.584l-11.442-9.535z",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render: render }